<template lang="html">
  <div class="faq">
    <Navbar />
    <div class="content-i">
      <div class="content-box">
        <div class="element-wrapper">
          <h6 class="element-header">{{ t('termsTitle', 'termsTitle')}}</h6>
          <div class="element-box">
            <div class="element-info">
              <div class="row align-items-center">
                <div class="col-sm-8">
                  <div class="element-info-with-icon">
                    <div class="element-info-icon">
                        <div class="os-icon os-icon-users">
                        </div>
                    </div>
                    <div class="element-info-text">
                        <h5 class="element-inner-header">{{ t('termsHeader', 'termsHeader')}}</h5>
                        <div class="element-inner-desc">{{ t('termsDesc','termsDesc') }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="project-box">
                <div class="col-12 px-0" v-if="terms">
                  <div v-for="(term, index) in terms">
                    <div class="col-12">
                      <a href="javascript:;" @click="downloadTermsFile(index)">
                        <span>{{ term }}</span>
                      </a>
                      <hr class="my-1">
                    </div>
                  </div>
                </div>
                <div v-else class="row justify-content-center">
                  <p class="text-muted">{{ t('noTermFilesAvailable', 'noTermFilesAvailable') }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>



<script>
import Navbar from '@/components/Navbar'
import Footer from '@/components/Helper_Components/Footer'
import { mapGetters } from 'vuex'
import { backendUrl } from '@/helpers/backendUrl.js'

export default {
  name: 'Terms',
  data() {
    return {
      terms: null
    }
  },
  components:{
    Navbar,
    Footer
  },
  computed:{
    ...mapGetters(['allTemplateDetails']),
    backendLink() {
      return backendUrl()
    }
  },
  created() {
    this.getAvailableTerms()
  },
  methods: {
    getAvailableTerms() {
      this.$store.dispatch('termsStore/getAvailableTerms').then((response) => 
      {
        if(response) {
          this.terms = response
        }
      }, this)
    },

    downloadTermsFile(filename) {
      this.$store.dispatch('tokenStore/createDownloadToken', null).then(response => {
        let accessToken = response
        let fileUrl = backendUrl() + '/downloadTermsFile/' + filename + '/' + accessToken
        fileUrl = fileUrl.replace('.pdf','');

        window.open(fileUrl, '_blank');
      })
    }
  },
  filters: {
    humanReadable: function(date) {
        return moment(date).format('MMMM Do YYYY, h:mm:ss a');
    }
  }
}
</script>